<template>
  <SidebarComponent /> <!-- Aggiungi il componente sidebar qui -->
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <!-- Titolo e Bottone per Creare un Nuovo Utente -->
        <div class="titolo-card">
          <h1>Elenco Ri contatti</h1>
        </div>

        <div class="message-box">
          <p>In questa sezione gestiremo tutti i contatti da ri-contattare aggiornando le informazioni qui sotto.</p>

        </div>
<!--
        <div class="info-container">
          <div class="info-box">Scade il 31 maggio.</div>
          <div class="info-box">È rateizzabile con Alma Pay in massimo 4 rate, anche con una rateizzazione già aperta con Alma.</div>
          <div class="info-box">I nuovi programmi partono dalla fine del percorso in essere dell’allieva.</div>
          <div class="info-box">Si può attivare sia online che in studio.</div>
          <div class="info-box">Non è cumulabile con nessun’altra offerta.</div>
          <div class="info-box">Attualmente non vale per chi vi chiederà di fare solo allenamento o solo dieta.</div>
        </div>
        -->

        <div class="loader" v-if="isLoading">
          <h4>CREAZIONE IN CORSO</h4>
        </div>

        <div class="search-container">
        <!--  <button @click="openCreateContactModal" class="create-user-button"><span class="material-icons">add_circle_outline</span></button>
          <button @click="openMultiContactModal" class="create-user-button"><span class="material-icons">control_point_duplicate</span></button> -->
          <button @click="openFiltriContactModal" class="create-user-button staff-button-neutral"><span class="material-icons">tune</span></button>
          <button @click="openMultiStatistic" class="create-user-button staff-button-neutral"><span class="material-icons">insights</span></button>
        </div>

        <div class="tickets">
          <table>
            <thead>
              <tr>
                <th>Azione</th>
                <th>Data inizio</th>
                <th>Scadenza</th>
                <th>Giorni</th>
                <th>Nome</th>
                <th>Cognome</th>
                <th>Studio</th>
                <th>Chiamata</th>
                <th>Stato</th>
                <th>Telefono</th>
                <th>Email</th>
                <th>Operatore</th>
                <th>Note</th>
                <th>Acquistato</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="contact in filteredContacts" :key="contact.uid"
                :class="{
                  'blue-row': contact.stato === 'ci pensa',
                  'orange-row': contact.stato === 'inviato messaggio',
                  'green-row': contact.stato === 'appuntamento studio' || contact.stato === 'interessato online',
                  'red-row': contact.stato === 'non risponde' || contact.stato === 'non interessata',
                  'purple-row': contact.stato === 'da ricontattare',
                }">
                <td>
                  <div class="buttons-container">
                    <button @click="deleteContact(contact)"><span class="material-icons">delete</span></button>
                  </div>
                </td>
                <td>{{ contact.inizio }}</td>
                <td>{{ contact.fine }}</td>
                <td>{{ contact.giorni }}</td>
                <td>{{ contact.name }}</td>
                <td>{{ contact.surname }}</td>
                <td>{{ contact.studio }}</td>
                <td>
                  <select v-model="contact.chiamata" @change="updateContactField(contact, 'chiamata')">
                    <option value="">Seleziona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </select>
                </td>
                <td>
                  <select v-model="contact.stato" @change="updateContactField(contact, 'stato')">
                    <option value="">Seleziona uno stato</option>
                    <option value="inviato messaggio">Inviato messaggio WA</option>
                    <option value="appuntamento telefonico">Appuntamento Telefonico</option>
                    <option value="appuntamento studio">Appuntamento studio</option>
                    <option value="interessato online">Interessato online</option>
                    <option value="da ricontattare">Da ricontattare</option>
                    <option value="non risponde">Non risponde</option>
                    <option value="ci pensa">Ci pensa</option>
                    <option value="non interessata">Non interessata</option>
                  </select>
                </td>
                <td>
                  <input type="textnumber" v-model="contact.telefono" @change="updateContactField(contact, 'telefono')">
                </td>
                <td>
                  <input type="texttable" v-model="contact.email" @change="updateContactField(contact, 'email')">
                </td>
                <td>
                  <select v-model="contact.operatore" @change="updateContactField(contact, 'operatore')">
                    <option value="">Seleziona un operatore</option>
                    <option value="Veronica">Veronica</option>
                    <option value="Michela">Michela</option>
                    <option value="Elisabetta">Elisabetta</option>
                    <option value="Valentina">Valentina</option>
                    <option value="Svetlana">Svetlana</option>
                    <option value="Giorgia">Giorgia</option>
                    <option value="Chiara">Chiara</option>
                    <option value="Simona">Simona</option>
                    <option value="Angy">Angy</option>
                    <option value="Noemi">Noemi</option>
                    <option value="Eleonora">Eleonora</option>
                  </select>
                </td>
                <td>
                  <input type="note" v-model="contact.note" @blur="updateContactField(contact, 'note')">
                </td>
                <td>
                  <select v-model="contact.acquistato" @change="updateContactField(contact, 'acquistato')">
                    <option disabled value="">Seleziona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                    <option value="ci pensa">ci pensa</option>
                    <option value="prossimomese">prossimo mese</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal per la Creazione di un Nuovo Contatto -->
  <div class="modal" v-if="showModal">
    <div class="modal-content">
      <span class="close" @click="closeModal">&times;</span>
      <h2>Crea Nuovo Contatto</h2>
      <form @submit.prevent="saveNewContact">
        <input type="text" v-model="newContact.name" placeholder="Nome" required />
        <input type="text" v-model="newContact.surname" placeholder="Cognome" />
        <input type="text" v-model="newContact.email" placeholder="Email" />
        <input type="text" v-model="newContact.telefono" placeholder="Telefono" required />
        <div>
          <select v-model="newContact.contattopreso" required>
            <option disabled value="">Da dove abbiamo preso il contatto</option>
            <option value="Sponsorizzata">Sponsorizzata</option>
            <option value="Facebook">Facebook</option>
            <option value="Instagram">Instagram</option>
            <option value="Bio Instagram">Bio Instagram</option>
            <option value="Telefono">Telefono</option>
            <option value="Whatsapp">Whatsapp</option>
            <option value="Email">Email</option>
          </select>
        </div>
        <button class="staff-button-positive" type="submit">Salva Contatto</button>
      </form>
    </div>
  </div>

  <!-- Modal per la Creazione di un Nuovo Contatto -->
  <div class="modal" v-if="showModal2">
    <div class="modal-content">
      <span class="close" @click="closeModal">&times;</span>
      <h2>Crea multi Contatto</h2>
      <textarea v-model="pastedData" placeholder="Incolla qui i dati...Nome Cognome Telefono"></textarea>
      <button @click="handlePasteData" class="create-reset-button">Copia Contatti</button>
    </div>
  </div>

  <!-- Modal per i filtri -->
  <div class="modal" v-if="showModal3">
    <div class="modal-content">
      <span class="close" @click="closeModal">&times;</span>
      <h2>Crea filtri Contatto</h2>
      <select v-model="filterByChiamata">
        <option value="">Seleziona se è stata chiamata</option>
        <option value="Si">Si</option>
        <option value="No">No</option>
      </select>

      <select v-model="filterByState">
        <option value="">Seleziona Stato</option>
        <option value="no_selection">Nessun elemento</option>
        <option value="inviato messaggio">Inviato messaggio WA</option>
        <option value="appuntamento telefonico">Appuntamento Telefonico</option>
        <option value="appuntamento studio">Appuntamento studio</option>
        <option value="interessato online">Interessato online</option>
        <option value="da ricontattare">Da ricontattare</option>
        <option value="non risponde">Non risponde</option>
        <option value="ci pensa">Ci pensa</option>
        <option value="non interessata">Non interessata</option>
      </select>

      <select v-model="filterByOperator">
        <option value="">Seleziona Operatore</option>
        <option value="Veronica">Veronica</option>
        <option value="Michela">Michela</option>
        <option value="Elisabetta">Elisabetta</option>
        <option value="Valentina">Valentina</option>
        <option value="Svetlana">Svetlana</option>
        <option value="Giorgia">Giorgia</option>
        <option value="Chiara">Chiara</option>
        <option value="Simona">Simona</option>
        <option value="Angy">Angy</option>
        <option value="Noemi">Noemi</option>
        <option value="Eleonora">Eleonora</option>
      </select>

      <select v-model="filterByContattoPreso">
        <option value="">Seleziona da dove arriva il contatto</option>
        <option value="Sponsorizzata">Sponsorizzata</option>
        <option value="Facebook">Facebook</option>
        <option value="Instagram">Instagram</option>
        <option value="Bio Instagram">Bio Instagram</option>
        <option value="Telefono">Telefono</option>
        <option value="Whatsapp">Whatsapp</option>
        <option value="Email">Email</option>
      </select>

      <select v-model="filterByStudio">
        <option value="">Seleziona lo studio</option>
        <option disabled value="">Seleziona</option>
        <option value="Tivoli Quartier generale">Tivoli Quartier generale</option>
        <option value="FF Genova">FF Genova</option>
        <option value="FF Bologna">FF Bologna</option>
        <option value="FF Bari">FF Bari</option>
        <option value="FF Pescara">FF Pescara</option>
        <option value="FF Firenze">FF Firenze</option>
        <option value="FF Torino">FF Torino</option>
        <option value="FF Napoli">FF Napoli</option>
        <option value="FF Milano">FF Milano</option>
        <option value="FF Milano Sempione">FF Milano Sempione</option>
        <option value="FF Milano Città Studi">FF Milano Città Studi</option>
        <option value="FF Roma">FF Roma</option>
        <option value="FF Roma Eur">FF Roma Eur</option>
        <option value="FF Salerno">FF Salerno</option>
        <option value="FF Cagliari">FF Cagliari</option>
        <option value="FF Padova">FF Padova</option>
      </select>

      <select v-model="filterByAcquistato">
        <option value="">Ha Acquistato?</option>
        <option value="Si">Si</option>
        <option value="No">No</option>
      </select>
      <div>
        <button @click="resetFilters" class="create-reset-button">Reset Filtri</button>
      </div>
    </div>
  </div>

  <!-- Modal per Visualizzare Statistiche -->
  <div class="modal" v-if="showModal4">
    <div class="modal-content">
      <span class="close" @click="closeModal">&times;</span>
      <h2>Statistiche Contatti</h2>
      <div>
        <p>Contatti Totali: {{ totalFilteredContacts }}</p>
        <p>Chiamati: {{ chiamateDiretteCount }}</p>
        <p>Ci pensa: {{ ciPensaCount }}</p>
        <p>Acquistato (da verificare): {{ acquistatoCount }}</p>
        <p>Non Risponde: {{ nonRispondeCount }}</p>
        <p>Da Ricontattare: {{ daRicontattareCount }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed, onBeforeUnmount } from 'vue';
import { getFirestore, collection, getDocs, query, orderBy, updateDoc, doc, addDoc, where, writeBatch, deleteDoc, onSnapshot } from 'firebase/firestore';
import SidebarComponent from '../SidebarComponent.vue';

export default {
  components: {
    SidebarComponent,
  },
  setup() {
    const contacts = ref([]);
    const cache = ref([]);
    const showModal = ref(false);
    const showModal2 = ref(false);
    const showModal3 = ref(false);
    const showModal4 = ref(false);
    const newContact = ref({ name: '', surname: '', email: '', contattopreso: '', telefono: '' });
    const pastedData = ref('');
    const db = getFirestore();
    const searchEmail = ref('');
    const searchPhone = ref('');
    const searchSurname = ref('');
    const startDate = ref('');
    const endDate = ref('');
    const filterByChiamata = ref('');
    const filterByState = ref('');
    const filterByOperator = ref('');
    const filterByStudio = ref('');
    const filterByAcquistato = ref('');
    const filterByContattoPreso = ref('');
    const isLoading = ref(false);
    let unsubscribe = null;

    const totalFilteredContacts = computed(() => filteredContacts.value.length);
    const chiamateDiretteCount = computed(() => filteredContacts.value.filter(contact => contact.chiamata === 'Si').length);
    const ciPensaCount = computed(() => filteredContacts.value.filter(contact => contact.stato === 'ci pensa').length);
    const acquistatoCount = computed(() => filteredContacts.value.filter(contact => contact.acquistato === 'Si').length);
    const nonRispondeCount = computed(() => filteredContacts.value.filter(contact => contact.stato === 'non risponde').length);
    const daRicontattareCount = computed(() => filteredContacts.value.filter(contact => contact.stato === 'da ricontattare').length);

    const fetchContacts = () => {
      const contactsQuery = query(collection(db, "ricontatti"), orderBy("giorni", "asc"));
      unsubscribe = onSnapshot(contactsQuery, (snapshot) => {
        let tempContacts = snapshot.docs.map(doc => ({ ...doc.data(), uid: doc.id }));
        applyFiltersToContacts(tempContacts);
      }, (error) => {
        console.error("Failed to fetch contacts: ", error);
      });
    };

    const applyFiltersToContacts = (contactsArray) => {
      let tempContacts = [...contactsArray];
      if (searchSurname.value) {
        tempContacts = tempContacts.filter(doc => doc.surname && doc.surname.toLowerCase().includes(searchSurname.value.toLowerCase()));
      }
      if (searchEmail.value) {
        tempContacts = tempContacts.filter(doc => doc.email && doc.email.toLowerCase() === searchEmail.value.toLowerCase());
      }
      if (searchPhone.value) {
        let phoneWithoutPrefix = searchPhone.value;
        let phoneWithPrefix = searchPhone.value.startsWith('+39') ? searchPhone.value : '+39' + searchPhone.value;
        tempContacts = tempContacts.filter(doc => doc.telefono && (doc.telefono === phoneWithoutPrefix || doc.telefono === phoneWithPrefix));
      }
      if (startDate.value && endDate.value) {
        const dayStart = new Date(startDate.value);
        dayStart.setHours(0, 0, 0, 0);
        const dayEnd = new Date(endDate.value);
        dayEnd.setHours(23, 59, 59, 999);
        tempContacts = tempContacts.filter(doc => {
          const docDate = doc.created_time && doc.created_time.toDate();
          return docDate && docDate >= dayStart && docDate <= dayEnd;
        });
      }
      cache.value = tempContacts;
      contacts.value = applyCurrentFilters(cache.value);
    };

    const resetFilters = () => {
      filterByChiamata.value = '';
      filterByState.value = '';
      filterByOperator.value = '';
      filterByStudio.value = '';
      filterByAcquistato.value = '';
      filterByContattoPreso.value = '';
      searchEmail.value = '';
      searchPhone.value = '';
      searchSurname.value = '';
      startDate.value = '';
      endDate.value = '';
      contacts.value = [...cache.value];
    };

    const deleteContact = async (contact) => {
      if (!contact.uid) {
        console.error("Invalid contact data: UID missing.");
        return;
      }
      if (!confirm("Sei sicuro di voler cancellare questo contatto?")) return;
      try {
        await deleteDoc(doc(db, "ricontatti", contact.uid));
        contacts.value = contacts.value.filter(c => c.uid !== contact.uid);
        cache.value = contacts.value;
        console.log('Contatto cancellato con successo');
      } catch (error) {
        console.error('Errore nella cancellazione del contatto:', error);
      }
    };

    const handlePasteData = () => {
      console.log('Dati incollati direttamente:', pastedData.value);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const lines = pastedData.value.trim().split(/\n/);
      const bulkContacts = lines.map(line => {
        const parts = line.split('\t');
        if (parts.length < 8) {
          console.error('Dati di riga incompleti:', line);
          return null;
        }
        const endDate = parseDateString(parts[1]);
        const timeDiff = endDate - today;
        const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        return {
          inizio: parts[0],
          fine: parts[1],
          giorni: daysDiff,
          name: parts[3],
          surname: parts[4],
          studio: parts[5],
          email: parts[6],
          telefono: parts[7],
        };
      }).filter(contact => contact !== null);
      console.log('Contatti da salvare:', bulkContacts);
      saveBulkContacts(bulkContacts);
    };

    function parseDateString(dateStr) {
      const [day, month, year] = dateStr.split('/');
      return new Date(year, month - 1, day);
    }

    const saveBulkContacts = async (contacts) => {
      const batch = writeBatch(db);
      for (const contact of contacts) {
        if (contact.telefono) {
          const phoneQuery = query(collection(db, "ricontatti"), where("telefono", "==", contact.telefono));
          const querySnapshot = await getDocs(phoneQuery);
          console.log(`Query trovati: ${querySnapshot.size}`);
          if (querySnapshot.empty) {
            const docRef = doc(collection(db, "ricontatti"));
            batch.set(docRef, {
              ...contact,
              created_time: new Date()
            });
          } else {
            console.log(`Contatto con telefono ${contact.telefono} già esistente.`);
          }
        }
      }
      try {
        await batch.commit();
        console.log('Contatti salvati con successo');
        fetchContacts();
      } catch (error) {
        console.error("Errore nel salvataggio dei ricontatti", error);
        return;
      }
    };

    const formatDate = (timestamp) => {
      if (timestamp instanceof Date) {
        return timestamp.toLocaleDateString("it-IT");
      } else if (timestamp && typeof timestamp.toDate === 'function') {
        const date = timestamp.toDate();
        return date.toLocaleDateString("it-IT");
      } else {
        return 'Data non valida';
      }
    };

    const openCreateContactModal = () => {
      showModal.value = true;
    };

    const openMultiContactModal = () => {
      showModal2.value = true;
    };

    const openFiltriContactModal = () => {
      showModal3.value = true;
    };

    const openMultiStatistic = () => {
      showModal4.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
      showModal2.value = false;
      showModal3.value = false;
      showModal4.value = false;
      newContact.value = { name: '', surname: '', email: '', contattopreso: '', telefono: '' };
    };

    const searchByPhone = async () => {
      if (searchPhone.value) {
        let phoneWithoutPrefix = searchPhone.value;
        let phoneWithPrefix = searchPhone.value.startsWith('+39') ? searchPhone.value : '+39' + searchPhone.value;
        const phonesToQuery = [phoneWithoutPrefix, phoneWithPrefix];
        const phoneQuery = query(collection(db, "ricontatti"), where("telefono", "in", phonesToQuery));
        try {
          const querySnapshot = await getDocs(phoneQuery);
          const combinedResults = querySnapshot.docs.map(doc => ({ ...doc.data(), uid: doc.id }));
          contacts.value = combinedResults;
        } catch (error) {
          console.error("Failed to fetch contacts:", error);
        }
      } else {
        fetchContacts();
      }
    };

    const searchBySurname = async () => {
      if (searchSurname.value) {
        const contactsRef = collection(db, "ricontatti");
        const orderedQuery = query(contactsRef, orderBy("created_time", "desc"));
        const querySnapshot = await getDocs(orderedQuery);
        const searchValueLower = searchSurname.value.toLowerCase();
        const filteredContacts = querySnapshot.docs.filter(doc => doc.data().surname.toLowerCase().includes(searchValueLower));
        contacts.value = filteredContacts.map(doc => ({ ...doc.data(), uid: doc.id }));
      } else {
        fetchContacts();
      }
    };

    const searchByEmail = async () => {
      if (searchEmail.value) {
        const emailQuery = query(collection(db, "ricontatti"), where("email", "==", searchEmail.value));
        const querySnapshot = await getDocs(emailQuery);
        contacts.value = querySnapshot.docs.map(doc => ({ ...doc.data(), uid: doc.id }));
      } else {
        fetchContacts();
      }
    };

    const saveNewContact = async () => {
      if (newContact.value.name && newContact.value.contattopreso && newContact.value.telefono) {
        const db = getFirestore();
        const phoneEntered = newContact.value.telefono;
        const phoneWithPrefix = phoneEntered.startsWith('+39') ? phoneEntered : '+39' + phoneEntered;
        const phoneWithoutPrefix = phoneEntered.startsWith('+39') ? phoneEntered.slice(3) : phoneEntered;
        try {
          const phoneQuery = query(collection(db, "ricontatti"), where("telefono", "in", [phoneWithPrefix, phoneWithoutPrefix]));
          const querySnapshot = await getDocs(phoneQuery);
          if (!querySnapshot.empty) {
            alert('Questo numero di telefono esiste già nel database.');
            return;
          }
          await addDoc(collection(db, "ricontatti"), {
            name: newContact.value.name,
            surname: newContact.value.surname,
            email: newContact.value.email || '',
            contattopreso: newContact.value.contattopreso,
            telefono: phoneEntered,
            created_time: new Date(),
          });
          closeModal();
        } catch (error) {
          console.error("Failed to add new contact: ", error);
        }
      } else {
        alert('Assicurati di inserire tutti i campi obbligatori: nome, cognome, contatto preso, e telefono.');
      }
    };

    const updateContactField = async (contact, field) => {
      if (contact && contact.uid) {
        const contactRef = doc(db, "ricontatti", contact.uid);
        try {
          await updateDoc(contactRef, {
            [field]: contact[field]
          });
          console.log(`Updated ${field}: `, contact[field]);
          if (searchSurname.value) {
            searchBySurname();
          }
        } catch (error) {
          console.error(`Failed to update contact ${field}: `, error);
        }
      } else {
        console.error("Invalid contact data or uid is missing.");
      }
    };

    onMounted(() => {
      fetchContacts();
    });

    onBeforeUnmount(() => {
      if (unsubscribe) {
        unsubscribe();
      }
    });

    const applyCurrentFilters = (contactsArray) => {
      return contactsArray.filter(contact => {
        const stateFilter = filterByState.value === 'no_selection' ? contact.stato === undefined : (!filterByState.value || contact.stato === filterByState.value);
        return stateFilter &&
          (!filterByOperator.value || contact.operatore === filterByOperator.value) &&
          (!filterByStudio.value || contact.studio === filterByStudio.value) &&
          (!filterByContattoPreso.value || contact.contattopreso === filterByContattoPreso.value) &&
          (!filterByAcquistato.value || contact.acquistato === filterByAcquistato.value) &&
          (!filterByChiamata.value || contact.chiamata === filterByChiamata.value);
      });
    };

    const filteredContacts = computed(() => {
      return applyCurrentFilters(cache.value);
    });

    return {
      contacts,
      cache,
      showModal,
      showModal2,
      showModal3,
      showModal4,
      newContact,
      openCreateContactModal,
      closeModal,
      saveNewContact,
      formatDate,
      searchEmail,
      searchSurname,
      searchByEmail,
      searchBySurname,
      updateContactField,
      handlePasteData,
      pastedData,
      openMultiContactModal,
      openMultiStatistic,
      filterByState,
      filterByOperator,
      filterByStudio,
      filteredContacts,
      filterByChiamata,
      openFiltriContactModal,
      filterByContattoPreso,
      filterByAcquistato,
      resetFilters,
      deleteContact,
      totalFilteredContacts,
      nonRispondeCount,
      daRicontattareCount,
      chiamateDiretteCount,
      searchByPhone,
      searchPhone,
      startDate,
      endDate,
      ciPensaCount,
      acquistatoCount,
      isLoading,
      applyFiltersToContacts,
    };
  },
};
</script>



<style scoped>
.buttons-container {
  display: flex;
  gap: 10px; /* Spazio tra i bottoni */
}

.buttons-container button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.message-box {
  background-color: #4CAF50;
  color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
  text-align: left;
  margin-bottom: 20px;
}

.message-box h2 {
  margin-top: 0;
  font-size: 1.5em;
  text-align: left;

}

.message-box p {
  margin: 10px 0 0;
  font-size: 1.2em;
}

</style>


